import React, { useEffect, useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Col,
  Row,
  // Carousel,
  Accordion,
  Card,
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import { Helmet } from "react-helmet-async";

import { IoArrowForwardOutline } from "react-icons/io5";
import { FiPlus, FiMinus } from "react-icons/fi";
import { FiClock } from "react-icons/fi";
import { PiGraduationCapLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
// import { FaWhatsapp } from "react-icons/fa";

// import SuccessStory from "../../assets/publicpageimg/review-avatar.png";

import HomeLogo from "../../assets/publicpageimg/skillediton-logo.png";

import heroImage from "../../assets/publicpageimg/hero-dashboard-2.png";

import User1 from "../../assets/publicpageimg/home-slider-img-1.png";
import User2 from "../../assets/publicpageimg/home-slider-img-2.png";
import User3 from "../../assets/publicpageimg/home-slider-img-3.png";

// import logos
import logo1 from "../../assets/publicpageimg/logo1.png";
import logo2 from "../../assets/publicpageimg/logo2.png";
import logo3 from "../../assets/publicpageimg/logo3.png";
import logo4 from "../../assets/publicpageimg/brandlogo/rn-logo.webp";
import logo5 from "../../assets/publicpageimg/brandlogo/astonish-law-logo.png";
import logo6 from "../../assets/publicpageimg/brandlogo/galaxy-diagnostics.svg";
import logo7 from "../../assets/publicpageimg/brandlogo/annapurna-logo.webp";
import logo8 from "../../assets/publicpageimg/brandlogo/yss-soundsystem-logo.webp";
import logo9 from "../../assets/publicpageimg/brandlogo/endocare-logo.webp";
import logo10 from "../../assets/publicpageimg/key-relief-logo.webp";
import logo11 from "../../assets/publicpageimg/innozen-logo.webp";
import logo12 from "../../assets/publicpageimg/linkstand-logo.webp";

// Why Choose Skilledition

import studentImg from "../../assets/publicpageimg/why-choose-skilledition.png";
import chartImg from "../../assets/publicpageimg/chartImg.png";

import projectIcon from "../../assets/publicpageimg/project.png";
import internshipIcon from "../../assets/publicpageimg/internship.png";
import mentorIcon from "../../assets/publicpageimg/mentor.png";
import curriculumIcon from "../../assets/publicpageimg/curriculum.png";

// portfolio images
// import Portfolio1 from "../../assets/publicpageimg/portfolio-e-commerce.png";
// import Portfolio2 from "../../assets/publicpageimg/portfolio-real-time-chat-app.png";
// import Portfolio3 from "../../assets/publicpageimg/Portfolio-img-3.png";

import Portfolio1 from "../../assets/publicpageimg/Portfolio-img-1.png";
import Portfolio2 from "../../assets/publicpageimg/Portfolio-img-2.png";
import Portfolio3 from "../../assets/publicpageimg/Portfolio-img-3.png";

// What kind of builder are you
import logicImage from "../../assets/publicpageimg/builder-1.png";
import aiImage from "../../assets/publicpageimg/builder-2.png";
import productImage from "../../assets/publicpageimg/builder-3.png";
import designImage from "../../assets/publicpageimg/builder-4.png";
import mobileImage from "../../assets/publicpageimg/builder-5.png";

// Industry-Focused Programs. Real Projects.
import frontendImg from "../../assets/publicpageimg/frontend-course.png";
// import frontendImg from "../../assets/publicpageimg/frontend-img.png";
import backnedImg from "../../assets/publicpageimg/backend-course.png";
// import backnedImg from "../../assets/publicpageimg/backend-img.png";
// import mernImg from "../../assets/publicpageimg/meran-stack-imh.png";
// import Subjectimg6 from "../../assets/publicpageimg/home-digital.png";

import HomeBanner from "../../assets/publicpageimg/ready-to-build-your-future.png";

import "./Home.css";

const reviews = [
  "Real-Time Internship",
  "100% Telugu Learning",
  "Real Project Experience",
  "Resume Building Support",
];

// const successStoriesData = [
//   {
//     name: "Sathish Kumar",
//     role: "Full Stack Developer",
//     image: SuccessStory,
//     description:
//       "We believe learning should be simple, accessible, and practical. Skilledition, a product of Digisphere, helped me gain hands-on experience with real projects, preparing me for a professional career in full-stack development.",
//   },
//   {
//     name: "Ravi Teja",
//     role: "Frontend Developer",
//     image: SuccessStory,
//     description:
//       "Skilledition provided structured learning with real-world projects. The mentorship and guidance helped me master HTML, CSS, JavaScript, and React, enabling me to build responsive and scalable frontend applications.",
//   },
//   {
//     name: "Anjali Sharma",
//     role: "UI/UX Designer",
//     image: SuccessStory,
//     description:
//       "The hands-on approach and industry exposure at Skilledition helped me build a strong design portfolio. I learned UI/UX best practices and gained the confidence to take on professional projects.",
//   },
//   {
//     name: "Rohit Verma",
//     role: "Backend Developer",
//     image: SuccessStory,
//     description:
//       "Skilledition’s backend course helped me understand Node.js, Express.js, and MongoDB in depth. Real-time projects and mentorship prepared me to develop scalable server-side applications for real clients.",
//   },
//   {
//     name: "Sneha Rao",
//     role: "Digital Marketing Specialist",
//     image: SuccessStory,
//     description:
//       "I learned SEO, social media marketing, and Google Ads through practical campaigns. Skilledition’s approach gave me real experience running marketing strategies, boosting both my skills and confidence.",
//   },
//   {
//     name: "Vivek Yadav",
//     role: "React Developer",
//     image: SuccessStory,
//     description:
//       "The frontend projects at Skilledition helped me grasp React fundamentals, component-based architecture, and state management. I now work confidently on complex web applications.",
//   },
//   {
//     name: "Meera Iyer",
//     role: "Content Marketing Manager",
//     image: SuccessStory,
//     description:
//       "Skilledition’s content and social media projects helped me develop real-world marketing strategies. The guidance on analytics and campaign planning made me job-ready in digital marketing.",
//   },
//   {
//     name: "Aditya Sharma",
//     role: "Full Stack Developer",
//     image: SuccessStory,
//     description:
//       "From beginner to advanced projects, Skilledition provided a practical path to mastering full-stack development. The mentorship and real-time project exposure made the learning experience highly effective.",
//   },
//   {
//     name: "Ritika Sen",
//     role: "SEO Specialist",
//     image: SuccessStory,
//     description:
//       "The SEO and paid marketing training at Skilledition gave me practical skills to optimize websites and run successful campaigns. I was able to implement strategies confidently in real projects.",
//   },
//   {
//     name: "Sahil Kapoor",
//     role: "Frontend & React Developer",
//     image: SuccessStory,
//     description:
//       "Skilledition’s project-based approach helped me strengthen my JavaScript and React skills. Building real projects under guidance made me industry-ready in frontend development.",
//   },
// ];

const faqsData = [
  {
    question:
      "What is Skilledition and how is it different from other learning platforms?",
    answer:
      "Skilledition is a skill-focused learning platform designed to help students and freshers gain industry-ready skills through practical courses, real-time projects, and internship support.",
  },
  {
    question: "Does Skilledition provide real-time project experience?",
    answer:
      "Yes, the platform emphasizes hands-on learning by offering real-time projects and practical assignments that reflect actual industry use cases.",
  },
  {
    question: "Who can join Skilledition courses?",
    answer:
      "Any student, fresher, or working professional who wants to upgrade skills in technology and digital domains can join Skilledition.",
  },

  {
    question: "Are courses available in local or easy-to-understand languages?",
    answer:
      "Skilledition offers industry-focused learning content in Telugu, making quality education accessible and easy to understand for every learner. ",
  },
  {
    question: "How does Skilledition support career growth?",
    answer:
      "We bridge the gap between learning and career growth through structured, skill-focused learning. Build practical knowledge, develop in-demand skills, and confidently take the next step in your career. ",
  },
];

const modulesData = [
  {
    id: 1,
    title: "Frontend Development",
    category: "frontend",
    description:
      "Learn HTML, CSS, JavaScript, and React to build responsive, interactive websites through hands-on projects and practical learning.",
    image: frontendImg,
    route: "/frontend-development",
    weeks: "6 - 7",
    whatsappMessage:
      "Hi, I am interested in the Frontend Developer program. I want to know more details.",
  },
  {
    id: 2,
    title: "Backend Development",
    category: "backend",
    description:
      "Learn Node.js, Express.js, MongoDB, and RESTful APIs to build secure backend applications through hands-on projects.",
    image: backnedImg,
    weeks: "4 - 5",
    route: "/backend-development",
    whatsappMessage:
      "Hi, I am interested in the Backend Developer program. Please share more information.",
  },
  // {
  //   id: 3,
  //   title: "MERN Stack Development",
  //   category: "fullstack",
  //   description: "Master the MERN stack to build full-stack web applications through hands-on, real-world projects.",
  //   image: mernImg,
  //   route: "/mern-stack",
  //   weeks: "11 - 12",
  //   whatsappMessage:
  //     "Hi, I am interested in the MERN Stack Developer course. I would like enrollment details.",
  // },
  // {
  //   id: 4,
  //   title: "Digital Marketing",
  //   category: "marketing",
  //   description: "Grow brands using SEO, Ads, and Social Media strategies.",
  //   image: Subjectimg6,
  //   route: "/digital-marketing",
  //   weeks: "5 - 6",
  //   whatsappMessage:
  //     "Hi, I am interested in the Digital Marketing program. Please guide me further.",
  // },
];

const Home = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [index, setIndex] = useState(0);
  const logos = [
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    logo7,
    logo8,
    logo9,
    logo10,
    logo11,
    logo12,
  ];
  const [activeKey, setActiveKey] = useState("0");
  const [activeTab, setActiveTab] = useState("all");
  const navigate = useNavigate();

  const filteredModules =
    activeTab === "all"
      ? modulesData
      : modulesData.filter((item) => item.category === activeTab);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % reviews.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Skilledition | Skill-Based Learning Platform for Tech & Digital
          Careers
        </title>

        <meta
          name="description"
          content="Skilledition helps learners build job-ready skills through industry-focused courses, real-world projects, mentorship, and internship opportunities. Learn, build, and grow your career."
        />

        <link rel="canonical" href="https://skilledition.in/" />

        {/* Open Graph / Social Share */}
        <meta
          property="og:title"
          content="Skilledition | Skill-Based Learning Platform for Tech & Digital Careers"
        />
        <meta
          property="og:description"
          content="Learn MERN stack, digital marketing, and in-demand tech skills with real-world projects and expert mentorship."
        />
        <meta property="og:url" content="https://skilledition.in/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner.png"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | Skill-Based Learning Platform for Tech & Digital Careers"
        />
        <meta
          name="twitter:description"
          content="Learn MERN stack, digital marketing, and in-demand tech skills with real-world projects and expert mentorship."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner.png"
        />
      </Helmet>

      <section className="skillediton-top-wrapper">
        {/* HEADER */}
        <Navbar expand="lg" className="skillediton-header">
          <Container>
            <Navbar.Brand as={Link} to="/" className="skillediton-logo">
              <img
                src={HomeLogo}
                alt="Skillediton logo"
                className="skillediton-logo-img"
              />
            </Navbar.Brand>

            <Navbar.Toggle className="skillediton-header-navbar-toggle" />
            <Navbar.Collapse>
              <Nav className="ms-auto skillediton-nav">
                <Nav.Link
                  as={Link}
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/courses"
                  className={location.pathname === "/courses" ? "active" : ""}
                >
                  Courses
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/internship-programme"
                  className={
                    location.pathname === "/internship-programme"
                      ? "active"
                      : ""
                  }
                >
                  Internship Programme
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/tutor-programme"
                  className={
                    location.pathname === "/tutor-programme" ? "active" : ""
                  }
                >
                  Tutor Programme
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/about"
                  className={location.pathname === "/about" ? "active" : ""}
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/contact"
                  className={location.pathname === "/contact" ? "active" : ""}
                >
                  Contact
                </Nav.Link>
                <Button
                  className="skillediton-join-now-btn d-flex align-items-center gap-2"
                  // onClick={() =>
                  //   window.open("https://wa.me/918143879627", "_blank")
                  // }
                  onClick={() => navigate("/signin")}
                >
                  {/* <FaWhatsapp /> */}
                  Register Now
                </Button>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* HERO */}
        {isHomePage && (
          <section className="skillediton-hero reveal">
            <Container>
              <div className="skillediton-hero-content">
                {/* SLIDING BADGE */}
                <div className="skillediton-review-badge">
                  <div className="skillediton-review-dots">
                    <span className="dot">
                      <img src={User1} alt="user" />
                    </span>
                    <span className="dot">
                      <img src={User2} alt="user" />
                    </span>
                    <span className="dot">
                      <img src={User3} alt="user" />
                    </span>
                  </div>
                  <span className="review-text">{reviews[index]}</span>
                </div>

                <h1>
                  Learn to Code. Build Real Skills. <br />
                  <span>Start Your Career</span>
                </h1>

                <p>
                  Work in a Professional Office Environment, Gain Real-Time
                  Internship Experience, and Build a Strong Career Foundation
                </p>

                <Button
                  className="skillediton-hero-btn"
                  onClick={() => navigate("/courses")}
                >
                  Start Learning Now <IoArrowForwardOutline />
                </Button>
              </div>

              <div className="skillediton-hero-image">
                <img src={heroImage} alt="Dashboard Preview" />
              </div>
            </Container>
          </section>
        )}
      </section>

      <section className="skilledition-brands-logos reveal">
        <Container>
          <p className="skilledition-brands-logos-title">
            Trusted across the founder and business owners
          </p>

          <div className="skilledition-brands-logos-slider">
            <div className="skilledition-brands-logos-track">
              {/* ORIGINAL LOGOS */}
              {logos.map((logo, index) => (
                <div
                  className="skilledition-brands-logos-item"
                  key={`logo-${index}`}
                >
                  <img src={logo} alt={`Brand ${index + 1}`} />
                </div>
              ))}

              {/* DUPLICATE LOGOS FOR SMOOTH LOOP */}
              {logos.map((logo, index) => (
                <div
                  className="skilledition-brands-logos-item"
                  key={`logo-duplicate-${index}`}
                >
                  <img src={logo} alt={`Brand ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="skilledition-homepage-why reveal">
        <Container>
          <div className="skilledition-homepage-why-container">
            <h2 className="skilledition-homepage-why-title">
              Why Choose Skilledition?
            </h2>

            <p className="skilledition-homepage-why-subtitle">
              Hands on learning through real projects that build strong skills,
              foster deeper understanding, and prepare you to thrive in your
              career journey.
            </p>

            <div className="skilledition-homepage-why-grid">
              {/* LEFT CARD */}
              <div className="skilledition-homepage-why-left">
                <img
                  src={studentImg}
                  alt="Happy Student"
                  className="skilledition-homepage-why-student-img"
                />
              </div>

              {/* CENTER CARD */}
              <div className="skilledition-homepage-why-center">
                <img
                  src={chartImg}
                  alt="Learning Analytics"
                  className="skilledition-homepage-why-chart-img"
                />
              </div>

              {/* RIGHT CARD */}
              <div className="skilledition-homepage-why-right">
                <div className="skilledition-homepage-why-feature">
                  <img src={internshipIcon} alt="Internship" />

                  <span>Internship Based Courses</span>
                </div>

                <div className="skilledition-homepage-why-feature">
                  <img src={projectIcon} alt="Projects" />
                  <span>Real-Time Projects </span>
                </div>

                <div className="skilledition-homepage-why-feature">
                  <img src={mentorIcon} alt="Mentorship" />
                  <span>Resume Building Support</span>
                </div>

                <div className="skilledition-homepage-why-feature">
                  <img src={curriculumIcon} alt="Curriculum" />
                  <span>Mentor Support</span>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="skilledition-portfolio-section reveal">
        <Container className="skilledition-portfolio-section-container">
          <h2 className="skilledition-portfolio-section-title">
            Build a Portfolio that Employers Love
          </h2>

          <Row className="skilledition-portfolio-section-grid">
            {/* CARD 1 */}
            <Col lg={6} md={12}>
              <div className="skilledition-portfolio-section-cardss">
                <div className="skilledition-portfolio-section-content">
                  <h4 className="skilledition-portfolio-section-card-title">
                    E-Commerce
                  </h4>
                  <p className="skilledition-portfolio-section-card-text">
                    Design and build a complete e-commerce application from
                    scratch just like real startups do.
                  </p>
                </div>

                <div className="skilledition-portfolio-section-image">
                  <img src={Portfolio1} alt="Ecommerce App" />
                </div>
              </div>
            </Col>

            {/* CARD 2 */}
            <Col lg={6} md={12}>
              <div className="skilledition-portfolio-section-cardss skilledition-portfolio-section-card-blue">
                <div className="skilledition-portfolio-section-image">
                  <img src={Portfolio2} alt="Chat App" />
                </div>

                <div className="skilledition-portfolio-section-content">
                  <h4 className="skilledition-portfolio-section-card-title">
                    Real-Time Chat App
                  </h4>
                  <p className="skilledition-portfolio-section-card-text">
                    Learn how modern apps enable instant communication using
                    real-time technology.
                  </p>
                </div>
              </div>
            </Col>

            {/* CARD 3 (FULL WIDTH) */}
            <Col lg={12}>
              <div className="skilledition-portfolio-section-card skilledition-portfolio-section-card-wide">
                <div className="skilledition-portfolio-section-content">
                  <h4 className="skilledition-portfolio-section-card-title">
                    Admin Dashboard (React + Charts) Data-Driven Product
                    Interface
                  </h4>
                  <p className="skilledition-portfolio-section-card-text">
                    Build a powerful admin dashboard used by product managers
                    and business teams.
                  </p>
                </div>

                <div className="skilledition-portfolio-section-image">
                  <img src={Portfolio3} alt="Admin Dashboard" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-builder-section reveal">
        <Container className="skilledition-builder-section-container">
          <h2 className="skilledition-builder-section-title">
            What kind of builder are you?
          </h2>

          <p className="skilledition-builder-section-subtitle">
            Choose what excites you most we’ll guide you to the right skills,
            projects, and internships.
          </p>

          {/* ROW 1 */}
          <Row className="skilledition-builder-section-grid">
            <Col lg={6} md={6} sm={12}>
              <div className="skilledition-builder-section-item">
                <div className="skilledition-builder-section-head">
                  <img
                    src={logicImage}
                    alt="Thinking in Logic"
                    className="skilledition-builder-icon"
                  />
                  <h4>Thinking in Logic</h4>
                </div>
                <p>Data • Algorithms • Problem Solving</p>
              </div>
            </Col>

            <Col lg={6} md={6} sm={12}>
              <div className="skilledition-builder-section-item">
                <div className="skilledition-builder-section-head">
                  <img
                    src={aiImage}
                    alt="Working with AI & Automation"
                    className="skilledition-builder-icon"
                  />
                  <h4>Working with AI & Automation</h4>
                </div>
                <p>AI Tools • Smart Systems • Future Tech</p>
              </div>
            </Col>
          </Row>

          {/* ROW 2 (CENTER) */}
          <Row className="skilledition-builder-section-grid skilledition-builder-section-middle">
            <Col lg={12}>
              <div className="skilledition-builder-section-item">
                <div className="skilledition-builder-section-head">
                  <img
                    src={productImage}
                    alt="Building Complete Products"
                    className="skilledition-builder-icon"
                  />
                  <h4>Build to Impact</h4>
                </div>
                <p>End-to-End Applications • Idea to Execution </p>
              </div>
            </Col>
          </Row>

          {/* ROW 3 */}
          <Row className="skilledition-builder-section-grid">
            <Col lg={6} md={6} sm={12}>
              <div className="skilledition-builder-section-item">
                <div className="skilledition-builder-section-head">
                  <img
                    src={designImage}
                    alt="Designing Experiences"
                    className="skilledition-builder-icon"
                  />
                  <h4>Designing Experiences</h4>
                </div>
                <p>UI/UX • Visual Design • Interaction</p>
              </div>
            </Col>

            <Col lg={6} md={6} sm={12}>
              <div className="skilledition-builder-section-item">
                <div className="skilledition-builder-section-head">
                  <img
                    src={mobileImage}
                    alt="Mobile-First Thinking"
                    className="skilledition-builder-icon"
                  />
                  <h4>Mobile-First Thinking</h4>
                </div>
                <p>Mobile App Development • Seamless User Experiences</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-modules-section reveal">
        <Container>
          {/* ===== TITLE ===== */}
          <Row className="mb-4">
            <Col lg={12} className="text-center">
              <h2 className="skilledition-modules-title">
                Industry-Focused Programs.
                <br />
                Real Projects.
              </h2>
              <p className="skilledition-modules-subtitle">
                At Skilledition, we provide learner-first, career-focused
                training through industry-relevant courses, hands-on projects,
                real-world internship experience, and helping you build strong
                fundamentals
              </p>
            </Col>
          </Row>

          {/* ===== TABS ===== */}
          <Row className="justify-content-center mb-5">
            <Col lg="auto">
              <Nav className="skilledition-modules-tabs">
                {[
                  { key: "all", label: "All Courses" },
                  { key: "frontend", label: "Frontend Development" },
                  { key: "backend", label: "Backend Development" },
                  // { key: "fullstack", label: "MERN Stack Development" },
                  // { key: "marketing", label: "Digital Marketing" },
                ].map((tab) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link
                      className={activeTab === tab.key ? "active" : ""}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
          </Row>

          {/* ===== MODULE CARDS ===== */}
          <Row>
            {filteredModules.map((module) => (
              <Col lg={4} md={6} className="mb-4" key={module.id}>
                <Card className="skilledition-module-card">
                  <div className="skilledition-module-image-wrapper">
                    <Card.Img
                      src={module.image}
                      className="skilledition-module-image"
                    />
                  </div>

                  <Card.Body>
                    <Card.Title className="skilledition-module-title">
                      {module.title}
                    </Card.Title>
                    <Card.Text className="skilledition-module-text">
                      {module.description}
                    </Card.Text>
                    <div className="skilledition-module-icons-section">
                      <span className="skilledition-module-icon-item">
                        <FiClock className="skilledition-module-icon" />
                        <span>{module.weeks} Weeks</span>
                      </span>

                      <span className="skilledition-module-icon-item">
                        <PiGraduationCapLight className="skilledition-module-icon" />
                        <span>Industry Certification</span>
                      </span>
                    </div>
                    <div className="skilledition-module-two-home-btn">
                      <Button
                        className="skilledition-module-two-home-btn11"
                        onClick={() => navigate(module.route)}
                      >
                        Details
                      </Button>

                      <Button
                        className="skilledition-module-btn"
                        // onClick={() =>
                        //   window.open(
                        //     `https://wa.me/918143879627?text=${encodeURIComponent(
                        //       module.whatsappMessage,
                        //     )}`,
                        //     "_blank",
                        //   )
                        // }
                        onClick={() => navigate("/signin")}
                      >
                        Enroll Now <IoArrowForwardOutline />
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}

            {/* ===== VIEW ALL COURSES CARD ===== */}
            <Col lg={4} md={6} className="mb-4">
              <Card
                className="skilledition-module-card skilledition-viewall-card"
                onClick={() => navigate("/courses")}
              >
                <Card.Body className="skilledition-viewall-body">
                  {/* <h4 className="skilledition-viewall-title">
                                        Explore All Programs
                                    </h4>
                                    <p className="skilledition-viewall-text">
                                        Browse our complete range of industry-focused courses and career tracks.
                                    </p> */}

                  <Button className="skilledition-viewall-btn">
                    View All Courses <IoArrowForwardOutline />
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section className="skilledition-stories-section reveal">
        <Container fluid className="p-0 skilledition-stories-container">
          <h2 className="skilledition-stories-title">Success Stories</h2>

          <Carousel
            indicators={false}
            controls={false}
            interval={4000}
            pause={false}
            className="skilledition-stories-carousel"
          >
            {successStoriesData.map((story, index) => (
              <Carousel.Item key={index}>
                <div className="skilledition-story-card">
                  <p className="skilledition-story-text">{story.description}</p>

                  <div className="skilledition-story-user">
                    <img
                      src={story.image}
                      alt={story.name}
                      className="skilledition-story-user-img"
                    />
                    <div className="skilledition-story-user-info">
                      <h6 className="skilledition-story-user-name">
                        {story.name}
                      </h6>
                      <span className="skilledition-story-user-role">
                        {story.role}
                      </span>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section> */}

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>
              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Ready to Build <br /> Your Future?
              </h2>

              <p className="skilledition-banner-section-text">
                Start your journey toward a successful career with <br />
                Skilledition.
              </p>

              <Button
                className="skilledition-banner-section-btn"
                onClick={() => navigate("/courses")}
              >
                Start Learning <IoArrowForwardOutline />
              </Button>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={HomeBanner}
                alt="Dashboard Preview"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Home;
